export enum CLUSTER_360_VIEW {
  TURNTABLE = 'TURNTABLE',
  INTERIOR_360 = 'INTERIOR_360',
}
